module.exports = __webpack_public_path__ + "static/media/product-1-front.f273d9ab.jpg";